import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { templateVariablesTextsPath } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
import { useLocaleKeys } from '~/i18n';
import { useNotificationParagraphs, useNotificationPreviewContext } from '../NotificationEmailPreview/NotificationEmailPreview.utils';
import { SegmentedText } from '../NotificationEmailPreview/SegmentedText';
import styles from './NotificationSmsPreview.module.scss';
import { GetNotificationSmsPreviewTID } from './NotificationSmsPreview.testIds';
export function NotificationSmsPreview(param) {
    let { message, templateVariables, vendorBusinessName, currentDate, testId = 'notification-sms-preview' } = param;
    const { NotificationSmsPreviewTestIds: testIds } = useMemo(()=>GetNotificationSmsPreviewTID(testId), [
        testId
    ]);
    const previewContext = useNotificationPreviewContext(vendorBusinessName, currentDate);
    const { t: templateVarTexts } = useLocaleKeys(templateVariablesTextsPath);
    const paragraphs = useNotificationParagraphs(message, templateVariables, previewContext, templateVarTexts);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        "data-testid": testIds.Root(),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.phoneFrame,
            "data-testid": testIds.PhoneFrame(),
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.bubble,
                "data-testid": testIds.Bubble(),
                children: [
                    paragraphs.map((segments, index)=>/*#__PURE__*/ _jsx(Typography, {
                            as: "p",
                            variant: "paragraph2",
                            weight: "light",
                            className: styles.paragraph,
                            testId: testIds.Paragraph(index),
                            children: /*#__PURE__*/ _jsx(SegmentedText, {
                                segments: segments,
                                unresolvedTestId: testIds.UnresolvedTag
                            })
                        }, index)),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.skeletonGroup,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.skeletonLine,
                                "data-testid": testIds.SkeletonLine(0)
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: cn(styles.skeletonLine, styles.short),
                                "data-testid": testIds.SkeletonLine(1)
                            })
                        ]
                    })
                ]
            })
        })
    });
}
